import { useTranslation } from 'react-i18next';

const whyCards = [
  {
    titleKey: 'why.card1.title',
    descKey: 'why.card1.desc',
    icon: 'ri-store-2-line',
    imgUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20display%20with%20various%20fashion%20sneakers%20and%20shoes%20arranged%20on%20a%20warm%20beige%20surface%2C%20soft%20natural%20window%20light%20from%20left%2C%20editorial%20product%20photography%2C%20cream%20and%20taupe%20tones%2C%20organized%20composition%2C%20sophisticated%20retail%20aesthetic&width=600&height=360&seq=why-card-01-v2&orientation=landscape',
  },
  {
    titleKey: 'why.card2.title',
    descKey: 'why.card2.desc',
    icon: 'ri-magic-line',
    imgUrl: 'https://readdy.ai/api/search-image?query=Close%20up%20macro%20shot%20of%20a%20magnifying%20glass%20examining%20fabric%20texture%20and%20stitching%20details%20on%20premium%20clothing%2C%20warm%20neutral%20beige%20background%2C%20soft%20diffused%20lighting%2C%20editorial%20quality%20control%20inspection%20aesthetic%2C%20sophisticated%20detail%20photography&width=600&height=360&seq=why-card-02-v2&orientation=landscape',
  },
  {
    titleKey: 'why.card3.title',
    descKey: 'why.card3.desc',
    icon: 'ri-lightbulb-line',
    imgUrl: 'https://readdy.ai/api/search-image?query=Elegant%20open%20notebook%20with%20handwritten%20notes%20next%20to%20fashion%20accessories%20and%20a%20warm%20coffee%20cup%20on%20a%20cream%20desk%2C%20natural%20morning%20light%2C%20cozy%20productive%20workspace%2C%20minimal%20editorial%20style%2C%20soft%20beige%20and%20warm%20neutral%20color%20palette&width=600&height=360&seq=why-card-03-v2&orientation=landscape',
  },
  {
    titleKey: 'why.card4.title',
    descKey: 'why.card4.desc',
    icon: 'ri-earth-line',
    imgUrl: 'https://readdy.ai/api/search-image?query=Stylized%20minimalist%20map%20of%20Europe%20with%20Germany%20highlighted%20in%20warm%20accent%2C%20surrounded%20by%20small%20fashion%20item%20icons%20on%20a%20cream%20background%2C%20editorial%20infographic%20aesthetic%2C%20soft%20warm%20tones%2C%20elegant%20design%20concept%20for%20international%20shipping&width=600&height=360&seq=why-card-04-v2&orientation=landscape',
  },
];

export default function WhySection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            {t('why.title')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-3xl mx-auto">
            {t('why.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {whyCards.map((card) => (
            <div
              key={card.titleKey}
              className="bg-background-50 rounded-xl border border-background-200/70 hover:border-accent-200 transition-colors group overflow-hidden"
            >
              <div className="w-full h-40 overflow-hidden">
                <img
                  src={card.imgUrl}
                  alt={t(card.titleKey)}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors flex-shrink-0">
                    <i className={`${card.icon} text-accent-600 text-base`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900">{t(card.titleKey)}</h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{t(card.descKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}